import { toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import {
  type ICallingListResponse,
  type IResponseFullAICallingAgent,
} from 'entities/AICalling/api/types'
import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi'
import { showAIAgentDisabledToast } from 'entities/AIAgent/actions/showAIAgentDisabledToast'
import { disableAgent } from 'pages/chatbot/pages/calling/actions/disableAgent/disableAgent'
import { showSuccessActivatedModal } from 'pages/chatbot/pages/calling/actions/showSuccessActivatedModal/showSuccessActivatedModal'

export const toggleCallingActive = async (
  item: ICallingListResponse,
  onSuccessUpdate: (response: IResponseFullAICallingAgent) => void
): Promise<void> => {
  const updateStatus = async (status: ICallingListResponse['status']) => {
    const { data } = await AiCallingApi.updateStatus(item.id, status)
    onSuccessUpdate(data)
  }

  const handleError = (error: unknown) => {
    logger.error(error)
    toastStore.add({
      type: 'error',
      title: 'Something went wrong, try again!',
    })
  }

  try {
    if (item.status === 'active') {
      await disableAgent({
        id: item.id,
        disableRequest: async () => {
          try {
            await updateStatus('disabled')
            showAIAgentDisabledToast()
          } catch (error) {
            handleError(error)
          }
        },
      })
    } else {
      await updateStatus('active')
      showSuccessActivatedModal()
    }
  } catch (error) {
    handleError(error)
  }
}
